// extracted by mini-css-extract-plugin
export default {"container":"Header_container__ogplU","logo":"Header_logo__hLUwo","menu":"Header_menu__x5tlG"};